import { MessageSquare, Download, XCircle, Plus } from "lucide-react";
import { Button } from "@shared/ui/button";
import { Card, CardContent } from "@shared/ui/card";

interface QuickActionsProps {
  consumerCount: number;
  onNotify: () => void;
  onExport: () => void;
  onReject: () => void;
  onAddNote: () => void;
  isExporting?: boolean;
  isRejecting?: boolean;
  currentStatus?: string;
}

export const QuickActions = ({
  consumerCount,
  onNotify,
  onExport,
  onReject,
  onAddNote,
  isExporting = false,
  isRejecting = false,
  currentStatus,
}: QuickActionsProps) => {
  const isAcknowledgeStatus =
    currentStatus?.toLowerCase() === "acknowledged" ||
    currentStatus?.toLowerCase() === "in progress";

  return (
    <Card className="border shadow-sm bg-white">
      <CardContent className="p-4">
        <h3 className="text-sm font-bold text-gray-900 mb-4 px-1 lowercase first-letter:uppercase">
          Quick Actions
        </h3>
        <div className="space-y-3">
          <Button
            variant="outline"
            className="w-full justify-start gap-3 bg-white border-gray-200 text-gray-700 hover:bg-gray-50 h-11 px-4 text-sm font-bold"
            onClick={onNotify}
          >
            <MessageSquare className="h-4.5 w-4.5" />
            Notify {consumerCount} consumers
          </Button>

          <Button
            variant="outline"
            className="w-full justify-start gap-3 bg-white border-gray-200 text-gray-700 hover:bg-gray-50 h-11 px-4 text-sm font-bold"
            onClick={onExport}
            disabled={isExporting}
          >
            <Download className="h-4.5 w-4.5" />
            {isExporting ? "Exporting..." : "Export consumer list"}
          </Button>

          <Button
            variant="outline"
            className="w-full justify-start gap-3 bg-red-500 text-white hover:bg-red-600 border-none h-11 px-4 text-sm font-bold disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={onReject}
            disabled={!isAcknowledgeStatus || isRejecting}
          >
            <XCircle className="h-4.5 w-4.5" />
            {isRejecting ? "Rejecting..." : "Reject request"}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
